const jwt_customizer = {
    general: 'เกิดข้อผิดพลาดขณะกำหนดค่าเคลมของโทเค็น กรุณาลองใหม่อีกครั้งในภายหลัง',
    can_not_create_for_admin_tenant: 'ไม่สามารถสร้างตัวปรับแต่งโทเค็นสำหรับผู้เช่าแอดมินได้',
};
export default Object.freeze(jwt_customizer);
